import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { dailyUpdates } from "@/mocks/comics";
import { categories } from "@/mocks/comics";

export default function ComicGrid() {
  const { t } = useTranslation();

  const tagClass: Record<string, string> = {
    hot: "bg-accent-500 text-white",
    new: "bg-secondary-500 text-white",
    recommend: "bg-primary-500 text-white",
    ongoing: "bg-foreground-800 text-white",
  };

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10">
          <div>
            <p className="text-sm font-semibold uppercase tracking-wider text-foreground-400">
              {t("grid.title_sub", "精选分类")}
            </p>
            <h2 className="mt-1 text-2xl md:text-4xl font-bold text-foreground-950 italic">
              {t("grid.title_main", "探索你的漫画世界")}
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-lg leading-relaxed">
            {t("grid.desc")}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {dailyUpdates.map((comic) => (
            <div key={comic.id} className="group cursor-pointer">
              <div className="relative rounded-2xl overflow-hidden aspect-[3/4] mb-3">
                <img
                  src={comic.imageUrl}
                  alt={comic.title}
                  title={comic.title + " - 在线漫画韩漫"}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              {comic.tag && (
                <span
                  className={`inline-block px-2 py-0.5 rounded-md text-xs font-medium mb-1.5 ${tagClass[comic.tag] || "bg-secondary-500 text-white"}`}
                >
                  {t("tag." + comic.tag, comic.tag)}
                </span>
              )}
              <h3 className="text-sm font-semibold text-foreground-950 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                {comic.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500">{comic.author}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {categories.slice(0, 8).map((cat) => (
            <Link
              key={cat.id}
              to={"/category/" + cat.id}
              className="flex items-center gap-3 px-4 py-3 rounded-xl bg-white border border-background-200 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 group"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                <i className={cat.icon + " text-lg"}></i>
              </div>
              <div>
                <span className="text-sm font-medium text-foreground-900">{cat.name}</span>
                <span className="block text-xs text-foreground-500">{cat.count} 部</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium hover:bg-foreground-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t("cta.view_all", "查看全部")}
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}